/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, Button, colors } from '@material-ui/core';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main
    }
  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
));

const SidebarNav = props => {
  const { pages, className, ...rest } = props;
  const user = useSelector(state => state.auth.user);
  const isManagement = useSelector(state => state.auth.isManagement);
  const profile = isManagement ? 'management' : 'normal';
  const currentOrganization = useSelector(state => state.auth.currentOrganization);

  const showPageBasedOnRoles = requiredRoles => {
    return !!user.roles.find(role => requiredRoles.indexOf(role.name) > -1);
  };

  const showPageBasedOnOrganizationRoles = requiredRoles => {
    return requiredRoles.indexOf(currentOrganization.pivot.role.name) !== -1;
  };

  const classes = useStyles();

  return (
    <List {...rest} className={clsx(classes.root, className)}>
      {pages.map(page => {
        if (page.profile && page.profile.findIndex(item => item === profile) === -1) {
          return null;
        }

        if (profile === 'management' && page.roles && !showPageBasedOnRoles(page.roles)) {
          return null;
        }

        if (
          profile === 'normal' &&
          page.organizationRoles &&
          currentOrganization &&
          !showPageBasedOnOrganizationRoles(page.organizationRoles)
        ) {
          return null;
        }

        return (
          <ListItem className={classes.item} disableGutters key={page.title}>
            {page.isExternal ? (
              <Button
                className={classes.button}
                disabled={page.isDisabled}
                href={page.to}
                target="_blank"
              >
                <div className={classes.icon}>{page.icon}</div>
                {page.title}
              </Button>
            ) : (
              <Button
                activeClassName={classes.active}
                className={classes.button}
                component={CustomRouterLink}
                to={page.to}
                disabled={page.isDisabled}
              >
                <div className={classes.icon}>{page.icon}</div>
                {page.title}
              </Button>
            )}
          </ListItem>
        );
      })}
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  pages: PropTypes.array.isRequired
};

SidebarNav.defaultProps = {
  className: ''
};

export default SidebarNav;
